import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

type PostProps = {
  image: string;
};

export const SmallPostCardBase = styled.div`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  height: 100%;
  position: relative;

  :hover .image,
  :focus .image {
    transform: scale(1.075);
  }
`;

export const ImageContainer = styled.div`
  border-radius: 5px;
  flex: 1;
  overflow: hidden;
  position: relative;
  aspect-ratio: 4 / 3;
`;

export const Image = styled(GatsbyImage)`
  object-fit: cover;
  transition: all 0.25s;
  height: 100%;
  width: 100%;
`;

export const PostTypeIcon = styled.i`
  margin-right: 4px;
`;

export const PostType = styled.div`
  color: #ffffff;
  text-shadow: 0 0 10px ${theme.colors.darkBlues[100]};
  position: absolute;
  top: 8px;
  left: 12px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  z-index: 1;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const SubjectLink = styled(Link)`
  text-decoration: none;
  ::after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: " ";
  }
`;
export const Title = styled.p`
  flex-basis: 100%; /* Take up full row */
  margin: 0 0 8px 0;
  color: ${theme.colors.darkBlues[90]};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ${theme.largerThan.md} {
    margin: 16px 0 4px 0;
  }
`;

const PostMetadataText = styled.div`
  color: ${theme.colors.darkBlues[75]};
  ${theme.text.xs}
  font-weight: ${theme.fontWeights.regular};
  min-height: 1rem;
  min-width: 1px;
`;

export const Author = styled(PostMetadataText)`
  ${theme.largerThan.md} {
    width: 50%;
  }
`;

export const Metadata = styled(PostMetadataText)`
  /* Display at top of parent on mobile */
  order: -1;
  margin-top: 4px;

  ${theme.largerThan.md} {
    text-align: right;
    display: initial;
    order: initial;
    margin-top: initial;
    width: 50%;
    margin-left: auto;
  }
`;
